module.exports = __webpack_public_path__ + "img/template-default.e65e10a2.png";